import { useTheme } from '@mui/material';

import type { FC } from 'react';
import type { YScale } from 'shared/components/charts/components/YAxis';
import type { Margin, YLabels } from 'shared/components/charts/types';

interface GridProps {
  margin: Pick<Margin, 'right' | 'left'>;
  width: number;
  yScale: YScale;
  yLabels: YLabels;
}

export const Grid: FC<GridProps> = ({ width, margin, yScale, yLabels }) => {
  const theme = useTheme();

  return (
    <g pointerEvents="none">
      {yScale.ticks(yLabels.length).map((y, index) => (
        <line
          key={y}
          x1={-margin.left}
          y1={yScale(y)}
          x2={width + margin.right}
          y2={yScale(y)}
          strokeWidth={index > 0 ? 1 : 2}
          stroke={theme.palette.divider}
        />
      ))}
    </g>
  );
};
